import { http } from '@/api/http';
import type { OperationResult, Schemas } from '@/api/shared';

export const diagnosesApi = {
  /** GET /persons/{guid}/diagnoses — OMIM diagnoses for a patient. */
  getDiagnoses: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<OperationResult<'getDiagnoses'>> =>
    http.get<OperationResult<'getDiagnoses'>>(
      `/persons/${encodeURIComponent(guid)}/diagnoses`,
      options,
    ),

  /** POST /persons/{guid}/diagnoses — create a diagnosis. */
  addDiagnosis: (
    guid: string,
    body: Schemas['DiagnosisInput'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['Diagnosis']> =>
    http.post<Schemas['Diagnosis']>(
      `/persons/${encodeURIComponent(guid)}/diagnoses`,
      body,
      options,
    ),

  /** PUT /persons/{guid}/diagnoses/{id} — update a diagnosis. */
  updateDiagnosis: (
    guid: string,
    id: string,
    body: Schemas['DiagnosisInput'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['Diagnosis']> =>
    http.put<Schemas['Diagnosis']>(
      `/persons/${encodeURIComponent(guid)}/diagnoses/${encodeURIComponent(id)}`,
      body,
      options,
    ),

  /** DELETE /persons/{guid}/diagnoses/{id}. */
  deleteDiagnosis: (
    guid: string,
    id: string,
    options?: { signal?: AbortSignal },
  ): Promise<undefined> =>
    http.delete<undefined>(
      `/persons/${encodeURIComponent(guid)}/diagnoses/${encodeURIComponent(id)}`,
      options,
    ),
};
